module.exports = __webpack_public_path__ + "static/media/flora_logo.b2fc8e2c.svg";